import CloseIcon from '@jbhi-fi/lanyard-ui/components/Icons/Close';
import { useProductCompare } from '../../context/ProductCompareProvider';
import { CompareProduct } from '../ProductCompareBar';
import React from 'react';
import dynamicallyResizeShopifyImageUrl from '@jbhi-fi/utils/src/resizeShopifyImage/resizeShopifyImage';
import { styles } from './ProductCompareThumbnail.css';
import { ProductImageFallback } from '../../../ProductImageFallback/ProductImageFallback';

export const ProductCompareThumbnail = ({ product }: { product: CompareProduct }) => {
  const { removeItemFromCompare } = useProductCompare();

  return (
    <div className={styles.item}>
      {product ? (
        <button
          className={styles.closeButton}
          onClick={() => removeItemFromCompare(product.sku)}
          data-testid="remove-item-compare-button"
        >
          <CloseIcon className={styles.closeIcon} data-testid="remove-item-compare-icon" />
        </button>
      ) : null}
      {product?.imageUrl ? (
        <img
          src={dynamicallyResizeShopifyImageUrl(product.imageUrl, '50x50')}
          className={styles.itemThumbnail}
          alt=""
        />
      ) : (
        <ProductImageFallback className={styles.itemThumbnail} />
      )}
    </div>
  );
};
